import { createFileRoute } from '@tanstack/react-router';
import { AppearanceSettingsPage } from '../../screens/settings/AppearanceSettings';

export const Route = createFileRoute('/settings/appearance')({
  component: AppearanceSettingsPage,
});
